/* eslint react-hooks/exhaustive-deps: "warn" */

import { useContext, useRef } from 'react';

import { ContentContext } from 'context/ContentContext';

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './MaActivityMidCtaSection.module.scss';

export const MaActivityMidCtaSection = () => {
  const { t } = useInt();
  const { secondaryNavigation } = useContext(ContentContext);
  const bookDemoSlug = secondaryNavigation?.book_demo?.slug;

  const wrapRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={wrapRef}>
      <Section background="#EEF1FA" className={styles.section}>
        <div className={styles.text}>
          <TitleBlock
            title={t('The opportunities nobody else has indexed.')}
            description={t(
              'Deal databases start at the funding round. Registries start at incorporation — so the founder-owned, never-funded, quietly compounding target is in the data.',
            )}
            align="left"
          />
        </div>

        {bookDemoSlug && (
          <div className={styles.btnWrap}>
            <Button type="blue" size="xl" route={bookDemoSlug}>
              {t('Book a demo')}
            </Button>
          </div>
        )}
      </Section>
    </div>
  );
};
